import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./HomePage.css";
import bgImage from "../img/Background_image.png";
import { Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import fig1Image from "../img/fig1.png";
import fig2Image from "../img/fig2.png";
import fig5Image from "../img/fig5.png";
import fig6Image from "../img/fig6.png";
import Logo from "../img/logo.png";

import berlin from '../img/company/berlin.png'
import esf from '../img/company/esf.jpg'
import hwr from '../img/company/hwr.png'
import sib from '../img/company/sib.jpg'

import { useNavigate, useLocation } from "react-router-dom";

function HomePage() {
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // Add this
  const { user, logout } = useAuth();

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const handleLogout = () => {
    logout();
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
      }, 100); // small delay for page to render
    } else {
      document.getElementById("features")?.scrollIntoView({ behavior: "smooth" });
    }
  };


  const HomehandleClick = (e) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById("home")?.scrollIntoView({ behavior: "smooth" });
      }, 100); // small delay for page to render
    } else {
      document.getElementById("home")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Helmet>
        <title>Revexia - Agentic Inbox</title>
        <meta
          name="description"
          content="Revexia tracks every DM interaction, predicts who will buy, and automatically sends the most effective offer across Instagram, Facebook, and TikTok."
        />
      </Helmet>

      <div className="homepage">
        {/* Navigation - Updated Design */}
        <nav className="navbar-custom">
          <div className="navbar-container">
            {/* Logo Section */}
            <div className="navbar-brand-custom">
              <Link to="/">
                <img src={Logo} alt="Revexia Logo" className="navbar-logo-img" />
              </Link>
            </div>

            {/* Center Navigation Pills */}
            <div className="navbar-center-pill">
              <ul className="nav-menu-pills">
                <li className="nav-item-pill">
                  {/* <Link to="/" className="nav-link-pill">
                    Home
                  </Link> */}

                  <a href="/#home" className="nav-link-pill" onClick={HomehandleClick}>
                    Home
                  </a>

                </li>
                <li className="nav-item-pill">
                  <a href="/#features" className="nav-link-pill" onClick={handleClick}>
                    Feature
                  </a>
                </li>

                <li className="nav-item-pill nav-item-dropdown">
                  <button className="nav-link-pill nav-dropdown-toggle">
                    Resources
                    <svg
                      width="10"
                      height="6"
                      viewBox="0 0 10 6"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="dropdown-arrow"
                    >
                      <path
                        d="M1 1L5 5L9 1"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                  <div className="nav-dropdown-menu">
                    <Link to="/how" className="nav-dropdown-item">
                      How it works
                    </Link>
                    <Link to="/support" className="nav-dropdown-item">
                      Support overview
                    </Link>
                    <Link to="/trust" className="nav-dropdown-item">
                      Trust Center
                    </Link>
                    <Link to="/privacy-policy" className="nav-dropdown-item">
                      Privacy Policy
                    </Link>
                    <Link to="/terms" className="nav-dropdown-item">
                      Terms of Service
                    </Link>
                    <Link to="/facebook-terms" className="nav-dropdown-item">
                      Facebook Terms
                    </Link>
                  </div>
                </li>
                <li className="nav-item-pill">
                  <Link to="/blog" className="nav-link-pill">
                    Blog
                  </Link>
                </li>
                
              </ul>
            </div>

            {/* Right Side - Auth Buttons */}
            <div className="navbar-auth-section">
              {user ? (
                <>
                  <Link to="/dm-activity" className="btn-nav-outline">
                    Dashboard
                  </Link>
                  <button onClick={handleLogout} className="btn-nav-gradient">
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/auth" className="btn-nav-gradient">
                    Get Started
                  </Link>
                   <Link to="/auth" className="btn-nav-gradientlogin">
                    Login
                  </Link>
                </>
                
              )}
            </div>

            {/* Mobile Toggle */}
            <button
              className="navbar-mobile-toggle"
              type="button"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <span className="navbar-toggler-icon-custom"></span>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="navbar-mobile-menu">
              <ul className="mobile-nav-list">
                <li>
                  <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                    Home
                  </Link>
                </li>

                <li >
                  <a href="/#features" onClick={(e) => {
                      setMobileMenuOpen(false);
                      handleClick(e);
                    }} >
                    Feature
                  </a>
                </li>
                
                <li>
                  <Link to="/how" onClick={() => setMobileMenuOpen(false)}>
                    How it works
                  </Link>
                </li>
                <li>
                  <Link to="/support" onClick={() => setMobileMenuOpen(false)}>
                    Support overview
                  </Link>
                </li>
                <li>
                  <Link to="/trust" onClick={() => setMobileMenuOpen(false)}>
                    Trust Center
                  </Link>
                </li>
                <li>
                  <Link to="/blog" onClick={() => setMobileMenuOpen(false)}>
                    Blog
                  </Link>
                </li>
                
              </ul>
              <div className="mobile-auth-buttons">
                {user ? (
                  <>
                    <Link
                      to="/dashboard"
                      className="btn-nav-outline"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Dashboard
                    </Link>
                    <button
                      onClick={() => {
                        handleLogout();
                        setMobileMenuOpen(false);
                      }}
                      className="btn-nav-gradient"
                    >
                      Logout
                    </button>
                  </>
                ) : (
                  <>
                    <Link
                      to="/auth"
                      className="btn-nav-gradient"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Login
                    </Link>
                  </>
                )}
              </div>
            </div>
          )}
        </nav>


        {/* Hero Section - Redesigned with Dashboard */}
        <section className="hero-section-redesigned" id="home">
          {/* Background Effects */}
          <div className="hero-bg-effects">
            {/* Background Image - Lamp Effect from Bottom to Top */}
            <div className="hero-bg-lamp-wrapper">
              <img src={bgImage} alt="" className="hero-bg-lamp-image" />
            </div>

            {/* Additional Gradient Overlay for Text Readability */}
            <div className="hero-gradient-overlay-top"></div>
          </div>

          <div className="container-hero-redesigned">
            {/* Hero Content - Top Section */}
            <div className="hero-content-top">
              <div className="hero-text-container">
                <h1 className="hero-main-title">
                  AI Revenue Brain for{" "}
                  Social DM
                  <span className="hero-gradient-text"> Commerce</span>
                </h1>
                <p className="hero-subtitle-text">
                  Revexia tracks every DM interaction, predicts who will buy,
                  and automatically sends the most effective offer to convert
                  audiences into customers across Instagram, Facebook, and
                  TikTok.
                </p>

                
              </div>
         

                <h4 style={{ color: "white", textAlign: "center" }}>
                  Get Priority Access
                </h4>


               

              {/* CTA Buttons */}
              <div className="hero-cta-container">

                <Link to="/auth?mode=signup" className="hero-btn-primary">
                  <span>Try the MVP — Free</span>
                </Link>
               
                <Link
                  to="/join-waitlist"
                  className="hero-btn-primary"
                  style={{ background: "#000", color: "#fff" }}
                >
                  <span style={{ color: "#fff" }}>Join Waitlist for Full Platform</span>
                </Link>
                {/* <button className="hero-btn-secondary">
                 
                  <div className="btn-gradient-overlay"></div>
                
                  <div className="btn-horizontal-divider"></div>
                 
                  <div className="btn-dot-glow btn-dot-1"></div>
                  <div className="btn-dot-normal btn-dot-2"></div>
                  <div className="btn-dot-small btn-dot-3"></div>
                 
                  <div className="btn-content-wrapper">
                    <svg
                      className="play-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M3 2L13 8L3 14V2Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="1.33"
                      />
                    </svg>
                    <span>Watch Demo</span>
                  </div>
                </button> */}
              </div>

              {/* Secondary CTA Button - Watch Demo */}
                <button className="cta-button-secondary">
                  {/* Gradient Overlay */}
                  <div className="button-gradient-overlay"></div>
                  {/* Horizontal Divider */}
                  <div className="button-horizontal-divider"></div>
                  {/* Animated Dots */}
                  <div className="button-dot-glow dot-1"></div>
                  <div className="button-dot-normal dot-2"></div>
                  <div className="button-dot-small dot-3"></div>
                  {/* Button Content */}
                  <div className="cta-button-content">
                    <svg
                      className="play-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M3.33325 2L12.6666 8L3.33325 14V2Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="1.33"
                      />
                    </svg>
                   <a
                      href="https://www.youtube.com/watch?v=G7D5c40whQA"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "black" }}
                    >
                      <span className="cta-button-text-secondary">
                        What is Revexia
                      </span>
                    </a>
                  </div>
                </button>
                
            </div>

            {/* Dashboard Mockup Container */}
            <div className="dashboard-mockup-container">
              {/* Stats Cards Row */}
              <div className="stats-cards-grid">
                {/* Stat Card 1 - DM Revenue */}
                <div className="stat-card-item">
                  <div className="stat-card-header-row">
                    <div className="stat-icon-box cyan-icon">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <rect
                          x="4"
                          y="4"
                          width="8"
                          height="8"
                          rx="1"
                          stroke="#22D3EE"
                          strokeWidth="1.33"
                        />
                      </svg>
                    </div>
                    <span className="stat-label-text">DM REVENUE</span>
                  </div>
                  <div className="stat-value-row">
                    <h3 className="stat-number">$124,592</h3>
                    <div className="stat-badge positive">
                      <svg width="12" height="12" viewBox="0 0 12 12">
                        <path d="M6 2L10 6L6 10L2 6Z" fill="#34D399" />
                        <path
                          d="M6 10V2"
                          stroke="#34D399"
                          strokeWidth="1"
                          strokeLinecap="round"
                        />
                      </svg>
                      <span>12.5%</span>
                    </div>
                  </div>
                  <div className="stat-progress-bar-bg">
                    <div
                      className="stat-progress-fill-bar blue-gradient"
                      style={{ width: "75%" }}
                    ></div>
                  </div>
                </div>

                {/* Stat Card 2 - % OFF */}
                <div className="stat-card-item">
                  <div className="stat-card-header-row">
                    <div className="stat-icon-box purple-icon">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <circle
                          cx="5"
                          cy="5"
                          r="2"
                          stroke="#C084FC"
                          strokeWidth="1.33"
                          fill="none"
                        />
                        <circle
                          cx="11"
                          cy="11"
                          r="2"
                          stroke="#C084FC"
                          strokeWidth="1.33"
                          fill="none"
                        />
                        <path
                          d="M4 12L12 4"
                          stroke="#C084FC"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <span className="stat-label-text">% OFF</span>
                  </div>
                  <div className="stat-value-row">
                    <h3 className="stat-number">4.8%</h3>
                    <div className="stat-badge positive">
                      <svg width="12" height="12" viewBox="0 0 12 12">
                        <path d="M6 2L10 6L6 10L2 6Z" fill="#34D399" />
                        <path
                          d="M6 10V2"
                          stroke="#34D399"
                          strokeWidth="1"
                          strokeLinecap="round"
                        />
                      </svg>
                      <span>0.8%</span>
                    </div>
                  </div>
                  <div className="stat-progress-bar-bg">
                    <div
                      className="stat-progress-fill-bar purple-gradient"
                      style={{ width: "75%" }}
                    ></div>
                  </div>
                </div>

                {/* Stat Card 3 - Follow-ups */}
                <div className="stat-card-item">
                  <div className="stat-card-header-row">
                    <div className="stat-icon-box pink-icon">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <circle
                          cx="4"
                          cy="12"
                          r="2"
                          stroke="#F472B6"
                          strokeWidth="1.33"
                          fill="none"
                        />
                        <circle
                          cx="12"
                          cy="4"
                          r="2"
                          stroke="#F472B6"
                          strokeWidth="1.33"
                          fill="none"
                        />
                        <path
                          d="M6 11L10 5"
                          stroke="#F472B6"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <span className="stat-label-text">FOLLOW-UPS</span>
                  </div>
                  <div className="stat-value-row">
                    <h3 className="stat-number">852</h3>
                    <div className="stat-text-badge">High Intent</div>
                  </div>
                  <div className="stat-progress-bar-bg">
                    <div
                      className="stat-progress-fill-bar orange-gradient"
                      style={{ width: "75%" }}
                    ></div>
                  </div>
                </div>

                {/* Stat Card 4 - Audience */}
                <div className="stat-card-item">
                  <div className="stat-card-header-row">
                    <div className="stat-icon-box blue-icon">
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                      >
                        <circle
                          cx="8"
                          cy="5"
                          r="2"
                          stroke="#60A5FA"
                          strokeWidth="1.33"
                          fill="none"
                        />
                        <path
                          d="M4 13C4 11 5.5 10 8 10C10.5 10 12 11 12 13"
                          stroke="#60A5FA"
                          strokeWidth="1.33"
                          strokeLinecap="round"
                        />
                      </svg>
                    </div>
                    <span className="stat-label-text">AUDIENCE</span>
                  </div>
                  <div className="stat-value-row">
                    <h3 className="stat-number">1.2M</h3>
                    <div className="stat-badge negative">
                      <svg width="12" height="12" viewBox="0 0 12 12">
                        <path d="M6 10L2 6L6 2L10 6Z" fill="#FB7185" />
                        <path
                          d="M6 2V10"
                          stroke="#FB7185"
                          strokeWidth="1"
                          strokeLinecap="round"
                        />
                      </svg>
                      <span>0.1%</span>
                    </div>
                  </div>
                  <div className="stat-progress-bar-bg">
                    <div
                      className="stat-progress-fill-bar blue-gradient"
                      style={{ width: "75%" }}
                    ></div>
                  </div>
                </div>
              </div>

              {/* Revenue Chart Section */}
              <div className="revenue-chart-section">
                {/* Chart Header */}
                <div className="chart-header-row">
                  <div className="chart-title-wrapper">
                    <h3 className="chart-main-title">Revenue Performance</h3>
                    <p className="chart-sub-description">
                      Real-time attribution data
                    </p>
                  </div>
                  <div className="chart-tabs-wrapper">
                    <button className="chart-tab-btn active">Revenue</button>
                    <button className="chart-tab-btn">Interactions</button>
                    <button className="chart-tab-btn">CTR</button>
                  </div>
                </div>

                {/* Chart Canvas Area */}
                <div className="chart-canvas-area">
                  {/* Grid Lines Background */}
                  <div className="chart-grid-lines">
                    <div className="grid-line-horizontal"></div>
                    <div className="grid-line-horizontal"></div>
                    <div className="grid-line-horizontal"></div>
                    <div className="grid-line-horizontal"></div>
                    <div className="grid-line-horizontal"></div>
                  </div>

                  {/* SVG Chart Visualization */}
                  <svg
                    className="chart-svg-canvas"
                    viewBox="0 0 1012 256"
                    preserveAspectRatio="none"
                  >
                    <defs>
                      <linearGradient
                        id="revenueChartGradient"
                        x1="0%"
                        y1="0%"
                        x2="0%"
                        y2="100%"
                      >
                        <stop offset="0%" stopColor="rgba(6, 182, 212, 0.2)" />
                        <stop offset="100%" stopColor="rgba(6, 182, 212, 0)" />
                      </linearGradient>
                    </defs>

                    {/* Area Fill Under Line */}
                    <path
                      d="M 0 180 C 120 170, 180 155, 250 145 C 320 135, 380 125, 450 120 C 520 115, 580 105, 650 100 C 720 95, 780 105, 850 110 C 920 115, 980 95, 1012 90 L 1012 256 L 0 256 Z"
                      fill="url(#revenueChartGradient)"
                    />

                    {/* Revenue Line */}
                    <path
                      d="M 0 180 C 120 170, 180 155, 250 145 C 320 135, 380 125, 450 120 C 520 115, 580 105, 650 100 C 720 95, 780 105, 850 110 C 920 115, 980 95, 1012 90"
                      stroke="#22D3EE"
                      strokeWidth="2"
                      fill="none"
                      strokeLinecap="round"
                    />

                    {/* Active Data Point */}
                    <circle
                      cx="600"
                      cy="100"
                      r="6"
                      fill="#083344"
                      stroke="#22D3EE"
                      strokeWidth="2"
                    >
                      <animate
                        attributeName="r"
                        values="6;8;6"
                        dur="2s"
                        repeatCount="indefinite"
                      />
                    </circle>
                  </svg>

                  {/* Tooltip Popup */}
                  <div
                    className="chart-tooltip-popup"
                    style={{ left: "60%", top: "30%" }}
                  >
                    <div className="tooltip-date-text">Nov 24</div>
                    <div className="tooltip-value-text">$8,402</div>
                    <div className="tooltip-arrow-down"></div>
                  </div>

                  {/* Vertical Line from Data Point */}
                  <div
                    className="chart-vertical-line"
                    style={{ left: "60%" }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Integration Section - Redesigned */}
        <section className="integration-section-new" id="integrations">

            {/* Bottom Section: Flow Diagram */}
            <div className="integration-flow-section">
              <h2 className="flow-diagram-title">
                Integration
              </h2>

              <div className="flow-diagram-wrapper">
                {/* SVG Connection Lines */}
                <svg
                  className="connection-lines-svg"
                  viewBox="0 0 831 391"
                  preserveAspectRatio="none"
                >
                  <defs>
                    <linearGradient id="lineGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="rgba(67, 111, 255, 0.8)" />
                      <stop offset="100%" stopColor="rgba(255, 73, 73, 0.8)" />
                    </linearGradient>
                    <linearGradient id="lineGradient2" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="rgba(67, 111, 255, 0.8)" />
                      <stop offset="100%" stopColor="rgba(92, 176, 255, 0.8)" />
                    </linearGradient>
                    <linearGradient id="lineGradient3" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="rgba(67, 111, 255, 0.8)" />
                      <stop offset="100%" stopColor="rgba(28, 195, 139, 0.8)" />
                    </linearGradient>
                    <linearGradient id="lineGradient4" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="rgba(67, 111, 255, 0.8)" />
                      <stop offset="100%" stopColor="rgba(29, 253, 40, 0.8)" />
                    </linearGradient>
                    <linearGradient id="lineGradient5" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="rgba(67, 111, 255, 0.8)" />
                      <stop offset="100%" stopColor="rgba(186, 90, 255, 0.8)" />
                    </linearGradient>
                    <linearGradient id="lineGradient6" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="rgba(67, 111, 255, 0.8)" />
                      <stop offset="100%" stopColor="rgba(247, 153, 1, 0.8)" />
                    </linearGradient>
                  </defs>

                  {/* Instagram */}
                  <path d="M 415.5 61 Q 225 180, 35 336"   stroke="url(#lineGradient1)" strokeWidth="2" fill="none" opacity="0.6" />
                  {/* Facebook */}
                  <path d="M 415.5 61 Q 305 190, 195 356"  stroke="url(#lineGradient2)" strokeWidth="2" fill="none" opacity="0.6" />
                  {/* TikTok */}
                  <path d="M 415.5 61 Q 380 150, 343 294"  stroke="url(#lineGradient3)" strokeWidth="2" fill="none" opacity="0.6" />
                  {/* Shopify */}
                  <path d="M 415.5 61 Q 455 170, 496 334"  stroke="url(#lineGradient4)" strokeWidth="2" fill="none" opacity="0.6" />
                  {/* Stripe */}
                  <path d="M 415.5 61 Q 530 140, 645 281"  stroke="url(#lineGradient5)" strokeWidth="2" fill="none" opacity="0.6" />
                  {/* Analytics */}
                  <path d="M 415.5 61 Q 605 165, 796 327"  stroke="url(#lineGradient6)" strokeWidth="2" fill="none" opacity="0.6" />
                </svg>

                {/* Central Hub */}
                <div className="flow-central-hub">
                  <div className="revexia-hub-badge">
                    <span className="hub-icon">
                      <img src={Logo} alt="Revexia" className="hub-icon-img" />
                    </span>
                  </div>
                </div>

                {/* Platform Icons Grid */}
                <div className="platform-icons-grid">

                  {/* Instagram */}
                  <div className="platform-icon-item instagram-platform">
                    <div className="platform-icon-box">
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <defs>
                          <linearGradient id="instagramGradient" x1="0%" y1="100%" x2="100%" y2="0%">
                            <stop offset="0%"   stopColor="#FED576" />
                            <stop offset="25%"  stopColor="#F47133" />
                            <stop offset="50%"  stopColor="#BC3081" />
                            <stop offset="100%" stopColor="#4C63D2" />
                          </linearGradient>
                        </defs>
                        <rect x="8" y="8" width="32" height="32" rx="7" fill="url(#instagramGradient)" />
                        <circle cx="24" cy="24" r="6.5" stroke="white" strokeWidth="2.5" fill="none" />
                        <rect x="13" y="13" width="22" height="22" rx="5" stroke="white" strokeWidth="2.5" fill="none" />
                        <circle cx="32" cy="16" r="2" fill="white" />
                      </svg>
                    </div>
                    <span className="platform-name">Instagram</span>
                  </div>

                  {/* Facebook */}
                  <div className="platform-icon-item facebook-platform">
                    <div className="platform-icon-box">
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <circle cx="24" cy="24" r="20" fill="#1877F2" />
                        <path d="M28.5 15.5H26c-1.38 0-2.5 1.12-2.5 2.5v3H21v4h2.5v10h4V25h3l0.5-4h-3.5v-2.5c0-0.55 0.45-1 1-1h2.5v-4z" fill="white" />
                      </svg>
                    </div>
                    <span className="platform-name">Facebook</span>
                  </div>

                  {/* TikTok */}
                    <div className="platform-icon-item tiktok-platform" style={{ opacity: 0.55 }}>
                      <div className="platform-icon-box">
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                          <rect x="4" y="4" width="40" height="40" rx="8" fill="black" />
                          <path d="M28 13h-4v18c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4c0.4 0 0.8 0.1 1.2 0.2v-4.4c-0.4-0.1-0.8-0.1-1.2-0.1-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8V21c1.8 1.2 4 1.9 6.3 1.9v-4c-2.5 0-4.7-1.5-5.7-3.6L28 13z" fill="#00F2EA" />
                          <path d="M28 13h-4v18c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4c0.4 0 0.8 0.1 1.2 0.2v-4.4c-0.4-0.1-0.8-0.1-1.2-0.1-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8V21c1.8 1.2 4 1.9 6.3 1.9v-4c-2.5 0-4.7-1.5-5.7-3.6L28 13z" fill="#FF004F" transform="translate(2, 2)" />
                        </svg>
                      </div>
                      <span className="platform-name">TikTok</span>
                      <span style={{
                        fontSize: '0.7rem',
                        fontWeight: 700,
                        color: '#808080',
                        fontStyle: 'italic',
                        marginTop: '0px',
                        display: 'block',
                        textAlign: 'center',
                      }}>
                        Comming soon
                      </span>
                    </div>

                  {/* Shopify */}
                  <div className="platform-icon-item shopify-platform">
                    <div className="platform-icon-box">
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <rect x="4" y="4" width="40" height="40" rx="4" fill="#95BF47" />
                        <path d="M31 16.5c0-0.2-0.2-0.3-0.3-0.3-0.1 0-2.5-0.1-2.5-0.1s-2-2-2.2-2.2c-0.2-0.2-0.6-0.1-0.8-0.1 0 0-0.4 0.1-1.1 0.3-0.1-0.4-0.4-0.9-0.7-1.3-1-1.2-2.4-1.8-4-1.7-0.1 0-0.2 0-0.3 0-0.1-0.1-0.2-0.2-0.3-0.3-0.8-0.8-1.8-1.2-2.9-1.1-2.3 0.1-4.5 1.7-6.3 4.4-1.2 1.9-2.2 4.2-2.4 6.2 0 0-3.8 1.2-4 1.2-1.2 0.4-1.2 0.4-1.4 1.6C4 23.5 4 40 4 40l24 4 16-3s-13-23.5-13-24.5zm-7.5-1.1c-0.6 0.2-1.3 0.4-2.1 0.6 0-1.3-0.2-3-1-4.4 1.9 0.3 2.8 2.4 3.1 3.8zm-3.9 1.2c-1.6 0.5-3.4 1-5.2 1.6 0.5-1.9 1.4-3.8 2.5-5.1 0.5-0.6 1.2-1.2 2-1.6 0.9 1.4 1.2 3.3 1.2 5.1zm-2.8-7.1c0.4 0 0.7 0.1 1 0.2-0.8 0.5-1.6 1.2-2.3 2-1.4 1.6-2.5 4-3 6.4-1.5 0.5-2.9 0.9-4.2 1.3 0.8-3.8 3.9-9.7 8.5-9.9z" fill="white" />
                      </svg>
                    </div>
                    <span className="platform-name">Shopify</span>
                  </div>

                  {/* ManyChat (was Stripe slot) */}
                  <div className="platform-icon-item stripe-platform">
                    <div className="platform-icon-box">
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <rect x="4" y="4" width="40" height="40" rx="8" fill="#635BFF" />
                        <g transform="translate(4, 4) scale(0.02, -0.02) translate(0, -2000)">
                          <path d="M1308 1431 c-91 -47 -171 -140 -233 -272 l-25 -54 0 133 0 132 -322 -2 -323 -3 -2 -382 -2 -383 130 0 129 0 0 255 0 255 70 0 70 0 0 -255 0 -255 138 0 139 0 13 58 c35 161 132 408 183 468 54 64 104 45 92 -35 -10 -69 -61 -221 -117 -351 -27 -63 -52 -121 -55 -127 -4 -10 35 -13 175 -13 l180 0 6 33 c44 247 56 600 23 693 -10 28 -33 66 -53 85 -32 31 -40 34 -107 36 -55 3 -81 -1 -109 -16z" fill="white" />
                        </g>
                      </svg>
                    </div>
                    <span className="platform-name">ManyChat</span>
                  </div>

                 {/* WooCommerce */}
                  <div className="platform-icon-item analytics-platform" style={{ opacity: 0.55 }}>
                    <div className="platform-icon-box">
                      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <rect x="4" y="4" width="40" height="40" rx="4" fill="#7f54b3" />
                        <polyline points="10,18 15,30 20,22 24,30 29,18" stroke="white" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
                        <line x1="10" y1="34" x2="38" y2="34" stroke="white" strokeWidth="1.5" strokeLinecap="round" opacity="0.5" />
                        <circle cx="18" cy="38" r="2" fill="white" />
                        <circle cx="30" cy="38" r="2" fill="white" />
                      </svg>
                    </div>
                    <span className="platform-name">WooCom</span>
                    <span style={{
                      fontSize: '0.7rem',
                      fontWeight: 700,
                      color: '#808080',
                      fontStyle: 'italic',
                      marginTop: '2px',
                      display: 'block',
                      textAlign: 'center',
                    }}>
                      Comming soon
                    </span>
                  </div>

                </div>
              </div>
            </div>






          <div className="container-integration my-5">
            <br/>
            {/* Top Section: Title + Three Cards */}
            <div className="integration-top-section">
              {/* Section Header */}
              <div className="integration-header-content">
                <h2 className="integration-main-title">
                  Integrates With Your DM Tools
                  <br />
                  And Acts Instantly
                </h2>
                <p className="integration-main-subtitle">
                  Your DM tool sends the message → Revexia decides what, when,
                  and who to send it to
                </p>
              </div>

              {/* Three Cards Row */}
              <div className="integration-cards-row">
                {/* Card 1: Input Source */}
               <div className="integration-card-item">
                <div className="integration-icon-wrapper">
                 <svg
                  id="Layer_1"
                  data-name="Layer 1"
                  width="60"
                  height="60"
                  viewBox="0 0 24 24"
                  fill="#5683FF"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m23.707 6.793c-.391-.391-1.023-.391-1.414 0l-4.537 4.537-5.027-5.027 4.487-4.605c.385-.396.377-1.029-.019-1.414-.395-.386-1.029-.377-1.414.019l-4.469 4.586-3.108-3.095c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l.99.99-5.292 5.291c-1.605 1.605-2.49 3.74-2.49 6.011 0 1.933.646 3.764 1.827 5.257l-1.535 1.536c-.39.391-.39 1.024 0 1.414.391.391 1.024.391 1.415 0l1.534-1.535c1.537 1.213 3.396 1.824 5.259 1.824 2.176 0 4.353-.828 6.01-2.485l5.293-5.293.99.99c.391.391 1.023.391 1.414 0s.391-1.023 0-1.414l-3.037-3.049 4.537-4.537c.391-.391.391-1.023 0-1.414zm-11.366 6.451-3.117.622 1.435 1.435c.418.418.573 1.03.401 1.598-.171.566-.638.991-1.219 1.107l-3.937.482c-.538.07-1.049-.321-1.114-.871-.067-.548.323-1.047.872-1.113l3.005-.367-1.388-1.388c-.36-.36-.53-.875-.456-1.378.087-.595.516-1.142 1.111-1.287l4.015-.801c.541-.108 1.068.243 1.176.785s-.243 1.068-.785 1.177z" />
                </svg>

                </div>
                <h3 className="integration-card-title">Input Source</h3>
                <p className="integration-card-description">
                  Your DM tool (IG, TikTok, FB) receives a customer interaction.
                </p>
              </div>


                {/* Card 2: Revexia Core - Featured */}
                <div className="integration-card-item-featured">
                  <div className="ai-processing-badge">AI PROCESSING UNIT</div>

                  <div className="integration-icon-wrapper">
                    <div className="integration-icon-wrapper">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      id="Layer_1"
                      data-name="Layer 1"
                      width="60"
                      height="60"
                      viewBox="0 0 24 24"
                      fill="#5683FF"
                    >
                      <path d="M11,17v3.946c0,1.368-.916,2.598-2.248,2.91-.402,.094-.821,.144-1.252,.144-2.422,0-4.515-1.556-5.233-3.835-1.408-.921-2.267-2.479-2.267-4.165,0-.886,.235-1.737,.686-2.5-.45-.763-.686-1.614-.686-2.5,0-1.568,.752-3.04,2-3.979v-.021c0-1.897,1.327-3.489,3.102-3.898,.409-1.774,2.002-3.102,3.898-3.102h.022c1.093,.003,1.978,.891,1.978,1.984v6.016h-2.277c-.346-.595-.984-1-1.723-1-1.105,0-2,.895-2,2s.895,2,2,2c.738,0,1.376-.405,1.723-1h2.277v5h-2.277c-.346-.595-.984-1-1.723-1-1.105,0-2,.895-2,2s.895,2,2,2c.738,0,1.376-.405,1.723-1h2.277Zm13-6c0-1.568-.752-3.04-2-3.979v-.021c0-1.897-1.327-3.489-3.102-3.898-.409-1.774-2.002-3.102-3.898-3.102h-.022c-1.093,.003-1.978,.891-1.978,1.984V12h3v-1.277c-.595-.346-1-.984-1-1.723,0-1.105,.895-2,2-2s2,.895,2,2c0,.738-.405,1.376-1,1.723v3.277h-5v6.946c0,1.368,.916,2.598,2.248,2.91,.402,.094,.821,.144,1.252,.144,2.422,0,4.515-1.556,5.233-3.835,1.408-.921,2.267-2.479,2.267-4.165,0-.886-.235-1.737-.686-2.5,.45-.763,.686-1.614,.686-2.5Z" />
                    </svg>

                    </div>

                  </div>

                  <h3 className="integration-card-title">Revexia Core</h3>

                  <ul className="integration-feature-list">
                    <li className="integration-feature-item">
                     <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Layer_1"
                        data-name="Layer 1"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="m8,12c-3.309,0-6-2.691-6-6S4.691,0,8,0s6,2.691,6,6-2.691,6-6,6Zm6.744,12c-.211,0-.422-.067-.6-.2-.34-.254-.481-.696-.354-1.101l.941-3.016-2.377-1.934c-.32-.271-.437-.713-.292-1.107.145-.394.519-.655.938-.655h3.001l1.062-2.98c.146-.391.52-.651.937-.651s.791.26.937.651l1.062,2.98h3.001c.42,0,.795.263.939.657s.026.837-.295,1.108l-2.366,1.927.979,2.98c.134.403-.002.847-.339,1.106-.337.259-.801.277-1.156.046l-2.754-1.793-2.708,1.812c-.168.113-.362.169-.556.169Zm-4.807,0H1c-.552,0-1-.448-1-1,0-4.962,4.038-9,9-9h.937c.346,0,.667.18.85.474.182.294.199.662.045.971-.552,1.11-.832,2.307-.832,3.555s.28,2.444.832,3.555c.154.31.137.678-.045.972-.182.294-.504.473-.85.473Z" />
                      </svg>


                      <span>Predicts Purchase Intent</span>
                    </li>
                    <li className="integration-feature-item">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <circle cx="12" cy="12" r="1.5" fill="currentColor" />
                        <circle cx="12" cy="4" r="1" fill="currentColor" />
                        <circle cx="19" cy="12" r="1" fill="currentColor" />
                        <circle cx="12" cy="20" r="1" fill="currentColor" />
                        <circle cx="5" cy="12" r="1" fill="currentColor" />
                        <circle cx="8" cy="7" r="1.2" fill="currentColor" />
                      </svg>
                      <span>Segments Audience</span>
                    </li>
                    <li className="integration-feature-item">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x="6"
                          y="6"
                          width="12"
                          height="12"
                          rx="2"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          fill="none"
                        />
                        <circle cx="15" cy="15" r="2" fill="currentColor" />
                        <circle
                          cx="15"
                          cy="15"
                          r="3"
                          stroke="currentColor"
                          strokeWidth="1"
                          fill="none"
                        />
                        <circle cx="18" cy="18" r="1.5" fill="currentColor" />
                        <circle cx="8" cy="6" r="2" fill="currentColor" />
                      </svg>
                      <span>Selects Best Offer</span>
                    </li>
                  </ul>
                </div>

                {/* Card 3: Customer Acts */}
                <div className="integration-card-item">
                  <div className="integration-icon-wrapper">
                    <svg width="60" height="60" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        fill="#5683FF"
                        d="M8,12c-3.309,0-6-2.691-6-6S4.691,0,8,0s6,2.691,6,6-2.691,6-6,6Z
                          m6.744,12c-.211,0-.422-.067-.6-.2-.34-.254-.481-.696-.354-1.101l.941-3.016
                          -2.377-1.934c-.32-.271-.437-.713-.292-1.107.145-.394.519-.655.938-.655h3.001
                          l1.062-2.98c.146-.391.52-.651.937-.651s.791.26.937.651l1.062,2.98h3.001
                          c.42,0,.795.263.939.657s.026.837-.295,1.108l-2.366,1.927.979,2.98
                          c.134.403-.002.847-.339,1.106-.337.259-.801.277-1.156.046l-2.754-1.793
                          -2.708,1.812c-.168.113-.362.169-.556.169Z
                          m-4.807,0H1c-.552,0-1-.448-1-1,0-4.962,4.038-9,9-9h.937
                          c.346,0,.667.18.85.474.182.294.199.662.045.971-.552,1.11-.832,2.307-.832,3.555
                          s.28,2.444.832,3.555c.154.31.137.678-.045.972-.182.294-.504.473-.85.473Z"
                      />
                    </svg>

                  </div>
                  <h3 className="integration-card-title">Customer Acts</h3>
                  <p className="integration-card-description">
                    Personalized offers convert followers into buyers
                    automatically.
                  </p>
                </div>
              </div>
            </div>

          



          </div>
        </section>

     

        {/* Features Section - Redesigned */}
        <section className="features-section-v2" id="features">
          <br/><br/><br/><br/>
          <div className="container-features-v2">
            {/* FEATURE 01 - AI Purchase Predictor */}
            <div className="feature-block">
              <div className="feature-content-left">
                <div className="feature-badge-v2">
                  <span>FEATURE : 01</span>
                </div>

                <h2 className="feature-title-v2">
                  AI signals that identify high-intent customers instantly.
                </h2>

                <p className="feature-description-v2">
                  Revexia's AI Purchase Predictor analyzes every customer
                  interaction views, clicks, messages, and timing on Social
                  media & Brand website to determine who is most ready to buy.
                </p>

                <ul className="feature-checklist">
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Predicts likelihood to purchase</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Helps avoid wasted effort on low-intent leads</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Updates automatically based on real behavior</span>
                  </li>
                </ul>
              </div>

              <div className="feature-visual-right">
                <div className="intent-predictor-card">
                  <img
                    src={fig1Image}
                    alt="Intent Predictor Dashboard"
                    className="intent-dashboard-image"
                  />
                </div>
              </div>
            </div>

            {/* FEATURE 02 - Perfect Offer */}
            <div className="feature-block feature-reverse">
              <div className="feature-content-left">
               <div className="feature-badge-v2">
                  <span>FEATURE : 02</span>
                  <span style={{
                    display: 'inline-block',
                    marginLeft: '8px',
                    fontSize: '0.55rem',
                    fontWeight: 900,
                    letterSpacing: '0.12em',
                    color: '#ffffff',
                    background: '#808080',
                    border: '1px solid #808080',
                    borderRadius: '999px',
                    padding: '0.15rem 0.55rem',
                    verticalAlign: 'middle',
                    textTransform: 'uppercase',
                  }}>
                    Comming Soon
                  </span>
                </div>

                <h2 className="feature-title-v2">
                  Send the Perfect Offer Automatically.
                </h2>

                <p className="feature-description-v2">
                  Revexia analyzes every customer's intent, behavior, timing,
                  and history to calculate the exact offer most likely to
                  convert them. AI that chooses 5%, 10%, bundles, or free
                  shipping based on what converts best.
                </p>

                <ul className="feature-checklist">
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>AI Offer Generator</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Dynamic Offer Brain</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Personalized incentives for each customer</span>
                  </li>
                </ul>
              </div>

              <div className="feature-visual-right">
                <div className="offer-comparison-card">
                  <img
                    src={fig2Image}
                    alt="Offer Comparison - AI Selection"
                    className="offer-comparison-image"
                  />
                </div>
              </div>
            </div>

            {/* FEATURE 03 - Audience Segmentation */}
            <div className="feature-block">
              <div className="feature-content-left">
                <div className="feature-badge-v2">
                  <span>FEATURE : 03</span>
                  <span style={{
                    display: 'inline-block',
                    marginLeft: '8px',
                    fontSize: '0.55rem',
                    fontWeight: 900,
                    letterSpacing: '0.12em',
                    color: '#ffffff',
                    background: '#808080',
                    border: '1px solid #808080',
                    borderRadius: '999px',
                    padding: '0.15rem 0.55rem',
                    verticalAlign: 'middle',
                    textTransform: 'uppercase',
                  }}>
                    Comming Soon
                  </span>
                </div>

                <h2 className="feature-title-v2">
                  Know Exactly Who Your Customers Are In Seconds.
                </h2>

                <p className="feature-description-v2">
                  Revexia instantly groups your entire audience based on how
                  they behave what they viewed, clicked, messaged, and
                  purchased. It continuously remembers customer context across
                  conversations, so every segment reflects real behavior from
                  your social media and website.
                </p>

                <ul className="feature-checklist">
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>RFM segmentation (Recency, Frequency, Monetary)</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>
                      Behavioral segments: viewers, clickers, engagers
                    </span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Auto-updated in real time</span>
                  </li>
                </ul>
              </div>

              <div className="feature-visual-right">
                <div className="segments-display-card">
                  <div className="segment-item">
                    <div className="segment-header">
                      <p className="segment-tag">SEGMENT</p>
                      <h4 className="segment-name">Whale Shoppers</h4>
                    </div>
                    <div className="segment-bar">
                      <div
                        className="segment-fill"
                        style={{ width: "20%", background: "#624DFF" }}
                      ></div>
                    </div>
                  </div>

                  <div className="segment-item">
                    <div className="segment-header">
                      <p className="segment-tag">SEGMENT</p>
                      <h4 className="segment-name">Window Shoppers</h4>
                    </div>
                    <div className="segment-bar">
                      <div
                        className="segment-fill"
                        style={{ width: "65%", background: "#3399FF" }}
                      ></div>
                    </div>
                  </div>

                  <div className="segment-item">
                    <div className="segment-header">
                      <p className="segment-tag">SEGMENT</p>
                      <h4 className="segment-name">Cart Abandoners</h4>
                    </div>
                    <div className="segment-bar">
                      <div
                        className="segment-fill"
                        style={{ width: "35%", background: "#FF8A31" }}
                      ></div>
                    </div>
                  </div>

                  <div className="segment-item">
                    <div className="segment-header">
                      <p className="segment-tag">SEGMENT</p>
                      <h4 className="segment-name">Loyalists</h4>
                    </div>
                    <div className="segment-bar">
                      <div
                        className="segment-fill"
                        style={{ width: "25%", background: "#51E217" }}
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* FEATURE 04 - Revenue Insights */}
            <div className="feature-block feature-reverse">
              <div className="feature-content-left">
               <div className="feature-badge-v2">
                  <span>FEATURE : 04</span>
                  <span style={{
                    display: 'inline-block',
                    marginLeft: '8px',
                    fontSize: '0.55rem',
                    fontWeight: 900,
                    letterSpacing: '0.12em',
                    color: '#ffffff',
                    background: '#808080',
                    border: '1px solid #808080',
                    borderRadius: '999px',
                    padding: '0.15rem 0.55rem',
                    verticalAlign: 'middle',
                    textTransform: 'uppercase',
                  }}>
                    Comming Soon
                  </span>
                </div>

                <h2 className="feature-title-v2">
                  Your Personal Revenue Analyst Powered by AI
                </h2>

                <p className="feature-description-v2">
                  If revenue dips, Revexia tells you exactly why whether it's
                  low engagement, weak offers, timing issues, or traffic drop.
                  It also detects product's sudden spike.
                </p>

                <ul className="feature-checklist">
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>"Why Revenue Dropped" insights</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Trend detection in products</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Recommended Next Best Actions</span>
                  </li>
                </ul>
              </div>

              <div className="feature-visual-right">
                <div className="revenue-insight-card">
                  <div className="insight-notification">
                    <div className="insight-icon">
                      <svg
                        id="Layer_1"
                        data-name="Layer 1"
                        width="32"
                        height="32"
                        viewBox="0 0 24 24"
                        fill="#5683FF"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="m20 24h-16c-.553 0-1-.447-1-1 0-3.309 2.691-6 6-6h6c3.309 0 6 2.691 6 6 0 .553-.447 1-1 1zm-10.013-14.6h1.067l-.519-2.494zm10.513-3.4h-.551c-.252-2.244-2.139-4-4.449-4h-2.5v-1c0-.552-.447-1-1-1s-1 .448-1 1v1h-2.5c-2.31 0-4.197 1.756-4.449 4h-.551c-.827 0-1.5.673-1.5 1.5v2c0 .827.673 1.5 1.5 1.5h.551c.252 2.244 2.139 4 4.449 4h7c2.31 0 4.197-1.756 4.449-4h.551c.827 0 1.5-.673 1.5-1.5v-2c0-.827-.673-1.5-1.5-1.5zm-8.227 6c-.385.017-.73-.246-.808-.625l-.078-.375h-1.751l-.084.383c-.079.36-.398.617-.767.617-.499 0-.872-.46-.768-.948l.993-4.668c.146-.755.76-1.383 1.523-1.383h.002c.782.004 1.368.603 1.534 1.423l.973 4.63c.102.488-.27.946-.768.946zm3.727-.8c0 .442-.358.8-.8.8s-.8-.358-.8-.8v-5.399c0-.442.358-.8.8-.8s.8.358.8.8z" />
                      </svg>

                    </div>
                    <p className="insight-text">
                      Revenue dropped 12% yesterday because engagement on the
                      "Summer Sale" post was lower than expected.
                    </p>
                  </div>

                  <div className="insight-recommendation">
                    <p className="recommendation-tag">RECOMMENDATION</p>
                    <p className="recommendation-text">
                      Resend the offer via DM to the "Warm Leads" segment at
                      6:00 PM today.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* FEATURE 05 - Journey Tracking */}
            <div className="feature-block">
              <div className="feature-content-left">
                <div className="feature-badge-v2">
                  <span>FEATURE : 05</span>
                  <span style={{
                    display: 'inline-block',
                    marginLeft: '8px',
                    fontSize: '0.55rem',
                    fontWeight: 900,
                    letterSpacing: '0.12em',
                    color: '#ffffff',
                    background: '#808080',
                    border: '1px solid #808080',
                    borderRadius: '999px',
                    padding: '0.15rem 0.55rem',
                    verticalAlign: 'middle',
                    textTransform: 'uppercase',
                  }}>
                    Comming Soon
                  </span>
                </div>

                <h2 className="feature-title-v2">DM Revenue Attribution</h2>

                <p className="feature-description-v2">
                  Track the entire DM → purchase journey. From the moment
                  someone comments to the purchase they make.
                </p>

                <ul className="feature-checklist">
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Comment → DM → Click → Checkout → Purchase</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Post → DM → Revenue tracking</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Real-time attribution dashboard</span>
                  </li>
                </ul>
              </div>

              <div className="feature-visual-right">
                <div className="attribution-display-card">
                  <img
                    src={fig5Image}
                    alt="Attribution Display - Payment Status"
                    className="attribution-display-image"
                  />
                </div>
              </div>
            </div>

            {/* FEATURE 06 - Auto Follow-up */}
            <div className="feature-block feature-reverse">
              <div className="feature-content-left">
               <div className="feature-badge-v2">
                <span>FEATURE : 06</span>
                <span style={{
                  display: 'inline-block',
                  marginLeft: '8px',
                  fontSize: '0.55rem',
                  fontWeight: 900,
                  letterSpacing: '0.12em',
                  color: '#ffffff',
                  background: '#808080',
                  border: '1px solid #808080',
                  borderRadius: '999px',
                  padding: '0.15rem 0.55rem',
                  verticalAlign: 'middle',
                  textTransform: 'uppercase',
                }}>
                  Comming Soon
                </span>
              </div>

                <h2 className="feature-title-v2">Follow-up Automation</h2>

                <p className="feature-description-v2">
                  Never Lose a Customer Again. Revexia automatically follows up
                  when the AI predicts they're most likely to convert.
                </p>

                <ul className="feature-checklist">
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Expanding window reminders</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Automated nudges</span>
                  </li>
                  <li>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path
                        d="M7 10l2 2 4-4"
                        stroke="#5683FF"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span>Behavior-based timing</span>
                  </li>
                </ul>
              </div>

              <div className="feature-visual-right">
                <div className="platforms-circle-card">
                  <img
                    src={fig6Image}
                    alt="Multi-Platform Integration"
                    className="platforms-circle-image"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section - Final Call to Action */}

        <section className="cta-section-final" id="cta">
          <style>{`
            .logo-marquee-wrapper {
              position: relative;
              width: 100%;
              max-width: 100%;
              overflow: hidden;
              margin-top: 48px;
              padding: 16px 0;
            }

            .logo-marquee-track {
              display: flex;
              width: max-content;
              animation: logo-marquee-scroll 30s linear infinite;
              will-change: transform;
            }

            .logo-marquee-group {
              display: flex;
              align-items: center;
              flex-shrink: 0;
            }

            .logo-marquee-item-box {
              width: 160px;
              height: 56px;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-shrink: 0;
            }

            .logo-marquee-item {
              height: 36px;
              width: auto;
              max-width: 140px;
              object-fit: contain;
              opacity: 0.85;
              transition: opacity 0.3s ease;
              display: block;
            }

            .logo-marquee-item:hover {
              opacity: 1;
            }

            @keyframes logo-marquee-scroll {
              from {
                transform: translateX(0);
              }
              to {
                transform: translateX(-25%);
              }
            }
          `}</style>

          <div className="container-cta-final">
            {/* Purple Gradient Blur Background */}
            <div className="cta-gradient-blur"></div>
            {/* CTA Content */}
            <div className="cta-content-wrapper">
              {/* Heading Container */}
              <div className="cta-heading-container">
                <h2 className="cta-main-heading">
                  Start Building Your AI Revenue Brain Today.
                </h2>
              </div>
              {/* Subheading Container */}
           
              {/* CTA Buttons */}
              <div className="cta-buttons-wrapper">
                {/* Primary CTA Button - Get Started */}
                
                  <Link to="/auth" className="contact-btn-primary">
                    <span className="cta-button-text">Get started</span>
                   </Link>
                  
             
                {/* Secondary CTA Button - Watch Demo */}
                {/* <button className="cta-button-secondary"> */}
                  {/* Gradient Overlay */}
                  {/* <div className="button-gradient-overlay"></div> */}
                  {/* Horizontal Divider */}
                  {/* <div className="button-horizontal-divider"></div> */}
                  {/* Animated Dots */}
                  {/* <div className="button-dot-glow dot-1"></div>
                  <div className="button-dot-normal dot-2"></div>
                  <div className="button-dot-small dot-3"></div> */}
                  {/* Button Content */}
                  {/* <div className="cta-button-content">
                    <svg
                      className="play-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M3.33325 2L12.6666 8L3.33325 14V2Z"
                        fill="white"
                        stroke="white"
                        strokeWidth="1.33"
                      />
                    </svg>
                   <a
                      href="https://www.youtube.com/watch?v=G7D5c40whQA"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "black" }}
                    >
                      <span className="cta-button-text-secondary">
                        What is Revexia
                      </span>
                    </a>
                  </div>
                </button> */}
              </div>
              {/* Partner Logos Marquee - Scrolling Ticker */}
              <div className="logo-marquee-wrapper">
                <div className="logo-marquee-track">
                  {[0, 1, 2, 3].map((groupIndex) => (
                    <div
                      className="logo-marquee-group"
                      key={groupIndex}
                      aria-hidden={groupIndex !== 0}
                    >
                      <div className="logo-marquee-item-box">
                        <img
                          src={berlin}
                          alt={groupIndex === 0 ? "Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={esf}
                          alt={groupIndex === 0 ? "European Social Fund" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={hwr}
                          alt={groupIndex === 0 ? "HWR Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                      <div className="logo-marquee-item-box">
                        <img
                          src={sib}
                          alt={groupIndex === 0 ? "Startup Incubator Berlin" : ""}
                          className="logo-marquee-item"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq-section-v2" id="faq">
          <div className="container-faq-v2">
            {/* FAQ Header */}
            <div className="faq-header-wrapper">
              <h2 className="faq-main-title">Frequently Asked Questions</h2>
              <p className="faq-supporting-text">
                Everything you need to know about the product.
              </p>
            </div>

           {/* FAQ Container */}
            <div className="faq-content-container">
              <div className="faq-items-wrapper">
                {/* FAQ Item 1 */}
                <div
                  className={`faq-item-v2 ${activeAccordion === 0 ? "active" : ""}`}
                >
                  <div className="faq-content-row">
                    <div className="faq-text-wrapper">
                      <button
                        className="faq-question-button"
                        onClick={() => toggleAccordion(0)}
                        aria-expanded={activeAccordion === 0}
                      >
                        <h3 className="faq-question-text">
                          What problem does Revexia solve?
                        </h3>
                      </button>
                      {activeAccordion === 0 && (
                        <div className="faq-answer-text">
                          <p>
                            Brands receive thousands of DMs, comments, and interactions —
                            but most of them never convert.
                          </p>
                          <p>Revexia helps brands:</p>
                          <ul>
                            <li>Understand who is most likely to buy</li>
                            <li>Avoid wasting time on low-intent conversations</li>
                            <li>Focus attention where revenue actually exists</li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <button
                      className="faq-icon-button"
                      onClick={() => toggleAccordion(0)}
                      aria-label="Toggle answer"
                    >
                      <svg
                        className="faq-icon-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {activeAccordion === 0 ? (
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="#A4A7AE"
                            strokeWidth="2"
                          />
                        ) : (
                          <>
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 8v8M8 12h8"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                {/* FAQ Item 2 */}
                <div
                  className={`faq-item-v2 ${activeAccordion === 1 ? "active" : ""}`}
                >
                  <div className="faq-content-row">
                    <div className="faq-text-wrapper">
                      <button
                        className="faq-question-button"
                        onClick={() => toggleAccordion(1)}
                        aria-expanded={activeAccordion === 1}
                      >
                        <h3 className="faq-question-text">
                          How is Revexia different from DM automation tools like ManyChat?
                        </h3>
                      </button>
                      {activeAccordion === 1 && (
                        <div className="faq-answer-text">
                          <p>
                            <strong>ManyChat and similar tools send messages.</strong>
                            <br />
                            <strong>Revexia decides who should receive attention.</strong>
                          </p>
                          <p>
                            Revexia works with your DM tool — it does not replace it.
                            Think of Revexia as the decision layer, not the messaging
                            layer.
                          </p>
                        </div>
                      )}
                    </div>
                    <button
                      className="faq-icon-button"
                      onClick={() => toggleAccordion(1)}
                      aria-label="Toggle answer"
                    >
                      <svg
                        className="faq-icon-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {activeAccordion === 1 ? (
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="#A4A7AE"
                            strokeWidth="2"
                          />
                        ) : (
                          <>
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 8v8M8 12h8"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                {/* FAQ Item 3 */}
                <div
                  className={`faq-item-v2 ${activeAccordion === 2 ? "active" : ""}`}
                >
                  <div className="faq-content-row">
                    <div className="faq-text-wrapper">
                      <button
                        className="faq-question-button"
                        onClick={() => toggleAccordion(2)}
                        aria-expanded={activeAccordion === 2}
                      >
                        <h3 className="faq-question-text">
                          Who is Revexia best for?
                        </h3>
                      </button>
                      {activeAccordion === 2 && (
                        <div className="faq-answer-text">
                          <p>Revexia is ideal for:</p>
                          <ul>
                            <li>E-commerce brands</li>
                            <li>Creator-led brands</li>
                            <li>Teams managing high DM volume</li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <button
                      className="faq-icon-button"
                      onClick={() => toggleAccordion(2)}
                      aria-label="Toggle answer"
                    >
                      <svg
                        className="faq-icon-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {activeAccordion === 2 ? (
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="#A4A7AE"
                            strokeWidth="2"
                          />
                        ) : (
                          <>
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 8v8M8 12h8"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                {/* FAQ Item 4 */}
                <div
                  className={`faq-item-v2 ${activeAccordion === 3 ? "active" : ""}`}
                >
                  <div className="faq-content-row">
                    <div className="faq-text-wrapper">
                      <button
                        className="faq-question-button"
                        onClick={() => toggleAccordion(3)}
                        aria-expanded={activeAccordion === 3}
                      >
                        <h3 className="faq-question-text">
                          Does Revexia integrate with Shopify?
                        </h3>
                      </button>
                      {activeAccordion === 3 && (
                        <div className="faq-answer-text">
                          <p>Yes.</p>
                        </div>
                      )}
                    </div>
                    <button
                      className="faq-icon-button"
                      onClick={() => toggleAccordion(3)}
                      aria-label="Toggle answer"
                    >
                      <svg
                        className="faq-icon-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {activeAccordion === 3 ? (
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="#A4A7AE"
                            strokeWidth="2"
                          />
                        ) : (
                          <>
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 8v8M8 12h8"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                {/* FAQ Item 5 */}
                <div
                  className={`faq-item-v2 ${activeAccordion === 4 ? "active" : ""}`}
                >
                  <div className="faq-content-row">
                    <div className="faq-text-wrapper">
                      <button
                        className="faq-question-button"
                        onClick={() => toggleAccordion(4)}
                        aria-expanded={activeAccordion === 4}
                      >
                        <h3 className="faq-question-text">
                          Do I need a DM automation tool to use Revexia?
                        </h3>
                      </button>
                      {activeAccordion === 4 && (
                        <div className="faq-answer-text">
                          <p>Yes.</p>
                          <p>
                            Revexia integrates on top of existing DM tools (like
                            ManyChat). This ensures:
                          </p>
                          <ul>
                            <li>Platform compliance</li>
                            <li>Reliable message delivery</li>
                            <li>No risk to your social accounts</li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <button
                      className="faq-icon-button"
                      onClick={() => toggleAccordion(4)}
                      aria-label="Toggle answer"
                    >
                      <svg
                        className="faq-icon-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {activeAccordion === 4 ? (
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="#A4A7AE"
                            strokeWidth="2"
                          />
                        ) : (
                          <>
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 8v8M8 12h8"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                {/* FAQ Item 6 */}
                <div
                  className={`faq-item-v2 ${activeAccordion === 5 ? "active" : ""}`}
                >
                  <div className="faq-content-row">
                    <div className="faq-text-wrapper">
                      <button
                        className="faq-question-button"
                        onClick={() => toggleAccordion(5)}
                        aria-expanded={activeAccordion === 5}
                      >
                        <h3 className="faq-question-text">
                          What data does Revexia analyze?
                        </h3>
                      </button>
                      {activeAccordion === 5 && (
                        <div className="faq-answer-text">
                          <p>Revexia analyzes:</p>
                          <ul>
                            <li>Social media conversations (DMs, replies, comments)</li>
                            <li>Customer engagement signals (clicks, views)</li>
                            <li>
                              Purchase and checkout behavior from your selling platform
                            </li>
                          </ul>
                          <p>
                            All data is used only to understand intent and improve
                            prioritization.
                          </p>
                        </div>
                      )}
                    </div>
                    <button
                      className="faq-icon-button"
                      onClick={() => toggleAccordion(5)}
                      aria-label="Toggle answer"
                    >
                      <svg
                        className="faq-icon-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {activeAccordion === 5 ? (
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="#A4A7AE"
                            strokeWidth="2"
                          />
                        ) : (
                          <>
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 8v8M8 12h8"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                {/* FAQ Item 7 */}
                <div
                  className={`faq-item-v2 ${activeAccordion === 6 ? "active" : ""}`}
                >
                  <div className="faq-content-row">
                    <div className="faq-text-wrapper">
                      <button
                        className="faq-question-button"
                        onClick={() => toggleAccordion(6)}
                        aria-expanded={activeAccordion === 6}
                      >
                        <h3 className="faq-question-text">
                          Is Revexia GDPR-compliant?
                        </h3>
                      </button>
                      {activeAccordion === 6 && (
                        <div className="faq-answer-text">
                          <p>Yes.</p>
                          <p>Revexia:</p>
                          <ul>
                            <li>Processes data on behalf of the brand</li>
                            <li>Does not sell or resell customer data</li>
                            <li>
                              Follows GDPR principles including data minimization and
                              purpose limitation
                            </li>
                          </ul>
                          <p>
                            Brands remain the data controller. Revexia acts as a data
                            processor.
                          </p>
                        </div>
                      )}
                    </div>
                    <button
                      className="faq-icon-button"
                      onClick={() => toggleAccordion(6)}
                      aria-label="Toggle answer"
                    >
                      <svg
                        className="faq-icon-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {activeAccordion === 6 ? (
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="#A4A7AE"
                            strokeWidth="2"
                          />
                        ) : (
                          <>
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 8v8M8 12h8"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                {/* FAQ Item 8 */}
                <div
                  className={`faq-item-v2 ${activeAccordion === 7 ? "active" : ""}`}
                >
                  <div className="faq-content-row">
                    <div className="faq-text-wrapper">
                      <button
                        className="faq-question-button"
                        onClick={() => toggleAccordion(7)}
                        aria-expanded={activeAccordion === 7}
                      >
                        <h3 className="faq-question-text">
                          Will Revexia work if my posts get few comments?
                        </h3>
                      </button>
                      {activeAccordion === 7 && (
                        <div className="faq-answer-text">
                          <p>Yes.</p>
                          <p>Revexia does not rely on comments alone. It combines:</p>
                          <ul>
                            <li>DM conversations</li>
                            <li>On-site behaviour on Selling platforms</li>
                            <li>Purchase signals</li>
                          </ul>
                          <p>
                            Even brands with low public engagement can uncover high-intent
                            buyers.
                          </p>
                        </div>
                      )}
                    </div>
                    <button
                      className="faq-icon-button"
                      onClick={() => toggleAccordion(7)}
                      aria-label="Toggle answer"
                    >
                      <svg
                        className="faq-icon-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {activeAccordion === 7 ? (
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="#A4A7AE"
                            strokeWidth="2"
                          />
                        ) : (
                          <>
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 8v8M8 12h8"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>

                {/* FAQ Item 9 */}
                <div
                  className={`faq-item-v2 ${activeAccordion === 8 ? "active" : ""}`}
                >
                  <div className="faq-content-row">
                    <div className="faq-text-wrapper">
                      <button
                        className="faq-question-button"
                        onClick={() => toggleAccordion(8)}
                        aria-expanded={activeAccordion === 8}
                      >
                        <h3 className="faq-question-text">
                          Will Revexia increase conversion rate?
                        </h3>
                      </button>
                      {activeAccordion === 8 && (
                        <div className="faq-answer-text">
                          <p>Revexia improves:</p>
                          <ul>
                            <li>Decision quality</li>
                            <li>Focus on high-intent customers</li>
                            <li>Conversion efficiency</li>
                          </ul>
                          <p>
                            Revenue outcomes depend on your product, pricing, and
                            execution.
                          </p>
                        </div>
                      )}
                    </div>
                    <button
                      className="faq-icon-button"
                      onClick={() => toggleAccordion(8)}
                      aria-label="Toggle answer"
                    >
                      <svg
                        className="faq-icon-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        {activeAccordion === 8 ? (
                          <circle
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="#A4A7AE"
                            strokeWidth="2"
                          />
                        ) : (
                          <>
                            <circle
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                            />
                            <path
                              d="M12 8v8M8 12h8"
                              stroke="#A4A7AE"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </>
                        )}
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/* Footer */}
        <footer className="footer-v2" id="contact">
          <div className="container-footer-v2">
            {/* Footer Main Content */}
            <div className="footer-main-content">
              {/* Brand Section */}
              <div className="footer-brand-section-v2">
                <div className="footer-logo-wrapper">
                  <img
                    src={Logo}
                    alt="Revexia"
                    className="footer-logo-image"
                  />
                </div>
                <p className="footer-brand-description-v2">
                  A platform to turn social media DM engagement into automated
                  revenue with AI-driven personalization.
                </p>
              </div>

              {/* Informations Column */}
              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Informations</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <a href="#home">Home</a>
                  </li>
                 
                </ul>
              </div>

              {/* Social Column */}
              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Social</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <a
                      href="https://www.facebook.com/share/1AhWEt4FyM/?mibextid=wwXIfr"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Facebook
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/revexia.ai/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Instagram
                    </a>
                  </li>
                  
                  <li>
                    <a
                      href="https://www.linkedin.com/company/revexiaai/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      LinkedIn
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/revexia.ai"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      TikTok
                    </a>
                  </li>
                </ul>
              </div>

              {/* Help Column */}
              <div className="footer-column-v2">
                <h4 className="footer-column-heading-v2">Help</h4>
                <ul className="footer-column-links-v2">
                  <li>
                    <Link to="/contact">Contact</Link>
                  </li>
                  
                  <li>
                    <Link to="/terms">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/facebook-terms">Facebook Terms</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* Footer Divider */}
            <hr className="footer-divider-line-v2" />

            {/* Footer Bottom - License */}
            <div className="footer-bottom-v2">
              <p className="footer-copyright-v2">
                ©2026 Revexia. All rights reserved. Developed by{" "}
                <a
                  href="https://softwarebari.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="developer-link"
                >
                  Softwarebari
                </a>
                .
              </p>
              <div className="footer-legal-links-v2">
                <Link to="/privacy-policy">Privacy Policy</Link>
                <span className="separator-v2">|</span>
                <Link to="/terms">Terms &amp;Conditions</Link>
                {/* <a href="#terms">Terms &amp; Conditions</a> */}
                <span className="separator-v2">|</span>
                <a href="#cookies">Cookies Policy</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}

export default HomePage;
